export default __webpack_public_path__ + "static/media/Incidents.6e1b2351.png";